import { InvoiceSummary } from '../../../store/data/types'
import { checkDelayedPayment, statusTranslator } from '../../../common/utils'
import { whatsappBillingCXLinkGenerator } from '../../../common/constants'
import {
  StyledInvoiceSummaryCard,
  StyledLink,
  StyledWrapper,
} from './styles/InvoiceSummaryCard.style'
import { useAppSelector } from '../../../common/hooks'
import { InvoiceCardTextContent } from './InvoiceCardTextContent'
import { InvoiceCardLinkBoard } from './InvoiceCardLinkBoard'
import { InvoiceCardHeader } from './InvoiceCardHeader'
import { RatingModule } from './RatingModule'
import { useLocation } from 'react-router-dom'

export const InvoiceSummaryCard = ({
  invoice,
  merchantCode: merchantCodeProp,
}: {
  invoice: InvoiceSummary
  merchantCode?: string
}) => {
  const location = useLocation()
  const merchantCodeFromRedux = useAppSelector((state) => state.session.merchantCode)
  const merchantCode = merchantCodeProp ?? merchantCodeFromRedux
  const {
    shopperPlanId,
    status,
    paymentType,
    totalDeliveredPrice,
    totalPrice,
    rating,
    billings,
    quantityOfPaymentInstallments,
    deliveryFinishDatetime,
    orderId,
  } = invoice

  const isPaymentDelayed = billings
    ? billings.find((billing) => checkDelayedPayment(billing.billingStatus))
    : false

  const isDeliverySummaryPage = location.pathname.startsWith('/delivery-summary/')

  return (
    <StyledInvoiceSummaryCard>
      <StyledWrapper>
        <InvoiceCardHeader
          title={`Entrega #${shopperPlanId}`}
          deliveryStatus={statusTranslator(status)}
          isPaymentDelayed={!!isPaymentDelayed}
        />
        {rating && !isDeliverySummaryPage && <RatingModule rating={rating} />}
      </StyledWrapper>
      <InvoiceCardTextContent
        paymentType={paymentType}
        billings={billings}
        quantityOfPaymentInstallments={quantityOfPaymentInstallments}
        totalDeliveredPrice={totalDeliveredPrice}
        totalPrice={totalPrice}
        deliveryFinishDatetime={deliveryFinishDatetime}
        orderId={orderId}
        isDeliverySummaryPage={isDeliverySummaryPage}
      />
      <InvoiceCardLinkBoard
        invoice={invoice}
        merchantCode={merchantCode}
        fromDeliverySummary={isDeliverySummaryPage}
      />
      {!!isPaymentDelayed && (
        <StyledLink
          href={whatsappBillingCXLinkGenerator(merchantCode, shopperPlanId)}
          target="_blank"
          rel="noreferrer"
        >
          Já efetuou o pagamento? Nos envie o comprovante por aqui
        </StyledLink>
      )}
    </StyledInvoiceSummaryCard>
  )
}
